import { UnscheduleSectionFacade } from '../../views/registration/facades/unschedule_section_facade';
import { ISection } from '../../interfaces/scheduler_interfaces';

class InactiveSectionBannerController {
  private section: ISection;

  constructor(private ngUnscheduleSectionFacade: UnscheduleSectionFacade) {}

  removeSection() {
    this.ngUnscheduleSectionFacade.unschedule(this.section);
  }
}

angular.module('capability-ng-scheduler').component('inactiveSectionBanner', {
  templateUrl: 'capability-ng-scheduler/src/components/inactive_section_banner/inactive_section_banner.html',
  controller: InactiveSectionBannerController,
  bindings: {
    section: '<'
  }
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/components/inactive_section_banner/inactive_section_banner.ts